import Qs from 'qs'
import FetchFactory from '../factory'

interface IWithdrawJob {
  params: {
    job_slug: string
  }
}

interface IMyJob {
  query: {
    page: number
  }
}

interface IMyJobSaved {
  query: {
    page: number
    filter: {
      search: string
    }
  }
}

class MyJobModule extends FetchFactory<any> {
    async getSavedJob(payload: IMyJobSaved) {
        const { query } = payload
        return await useAsyncData(() => {
            return super.call(
                `/api/job-seeker/my-jobs/saved?${Qs.stringify(query)}`,
                {
                    method: 'GET',
                },
      )
        })
    }

    async getAppliedJob(payload: IMyJob) {
        const { query } = payload
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/my-jobs/applied', {
                method: 'GET',
                query
            })
        })
    }

    async getContactedJob(payload: IMyJob) {
        const { query } = payload
        return await useAsyncData(() => {
            return super.call('/api/job-seeker/my-jobs/contacted', {
                method: 'GET',
                query
            })
        })
    }

    async withdrawJob(payload: IWithdrawJob) {
        const { params } = payload

        return await useAsyncData(() => {
            return super.call(
                `/api/job-seeker/my-jobs/${params.job_slug}/withdraw`,
                {
                    method: 'POST',
                },
      )
        })
    }
}

export default MyJobModule
